/**
 * Router error handler - handles navigation errors with cache clearing
 *
 * This is primarily used to handle chunk loading failures during navigation.
 * When a navigation error occurs, it reloads the page with ?eraseCache=true
 * to force a fresh load of all assets.
 *
 * Common causes:
 * - Stale JavaScript chunks after deployment
 * - Network errors during lazy component loading
 * - Webpack/Vite chunk loading failures
 */
export function routerErrorHandler(error, to) {
    if (!to.query?.eraseCache) {
        const baseUrl = `${location.protocol}//${location.host}`;
        const fullPath = to.fullPath || '';
        const separator = fullPath.includes('?') ? '&' : '?';

        window.location = `${baseUrl}${fullPath}${separator}eraseCache=true`;
        return;
    }

    // Cache-busting already attempted — surface the error so it's not silently swallowed
    console.error('[RouterErrorHandler] Navigation error persists after cache bust:', error);
}
